import { render, staticRenderFns } from "./NavBar.vue?vue&type=template&id=4295d220&"
import script from "./NavBar.vue?vue&type=script&lang=js&"
export * from "./NavBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\www\\aliventa\\gruene-hex\\admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4295d220')) {
      api.createRecord('4295d220', component.options)
    } else {
      api.reload('4295d220', component.options)
    }
    module.hot.accept("./NavBar.vue?vue&type=template&id=4295d220&", function () {
      api.rerender('4295d220', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/NavBar.vue"
export default component.exports